import { useState } from "react";
import { useDictionary } from "../../contexts/dictionary";
import { Col,List,ListItem } from "../../style/base.style";
import { TextLink } from "../../components/common/TextLink";

interface BenefitsProps {
    benefits: string[];
    hideButton?: boolean;
}
export const ServiceBenefits = ({ benefits,hideButton }:BenefitsProps) => {
    const {translate} = useDictionary();
    const [showAll,setShowAll] = useState<boolean>(hideButton===true);

    const showCount = (showAll || hideButton)? benefits.length : 5;
    return (
        <Col $margin="20px 0px" $gap={10}>
        <List>
            {benefits.slice(0, showCount).map((benefit, index) => (
                <ListItem key={index}>{translate(benefit)}</ListItem>
            ))}
        </List>
        {
            !hideButton &&
            <TextLink onClick={()=>setShowAll(prev=>!prev)} fontSize="14px" fontColor="#007bff">{showAll ? translate('show_less') : translate('show_more')}</TextLink>

        }
        
        
</Col>
    )

};